module.exports = __webpack_public_path__ + "img/x-circle.bc2137f4.svg";